import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import { pivotreeLightTheme } from './pivotreeTheme';

const pivotreeLightThemeExtension = ThemeBlueprint.make({
  name: 'pivotree-light',
  params: {
    theme: {
      id: 'pivotree-light',
      title: 'Pivotree Light',
      variant: 'light',
      icon: <WbSunnyIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={pivotreeLightTheme} children={children} />
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [pivotreeLightThemeExtension],
});
